// @flow
import React from 'react';
import {Input} from 'reactstrap'
import AbstractField from "./AbstractField";

/**
 * Klasický select
 */
class SelectField extends AbstractField {
    render() {
        const {addonsBefore, addonsAfter, children, ...props} = this.props;

        const field = <Input
            type="select"
            {...props}
        >
            {children}
        </Input>;

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}
export default SelectField;
